import React, { FC, useMemo } from "react";
import { Field, useForm, useFormState } from "react-final-form";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core";
import IconButton from "../../../../../components/IconButton";
import FontIcon from "../../../../../components/FontIcon";
import Button from "../../../../../components/Button";
import BootstrapInput from "../../../../../components/BootstrapInput";
import { ICourseComponentProps } from "../../../types";

const useStyles = makeStyles(() => ({
  addNewButton: {
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    height: 40,
    color: "#fefefe",
    backgroundColor: "#7ec884",
    padding: "0 12px!important",
  },
  otherDoc: {
    marginTop: 16,
  },
  removeOtherDocButton: {
    marginTop: 24,
    marginLeft: 18,
    padding: 10,
  },
  addNewButtonContainer: {
    textAlign: "right",
    marginTop: 16,
  },
  fieldArrayContainer: {
    display: "flex",
    flexDirection: "column-reverse",
  },
}));

const AdditionalRequiredDocs: FC<ICourseComponentProps> = ({
  fieldsGroupName,
}) => {
  const classes = useStyles();

  const { values } = useFormState();
  const { change } = useForm();

  const additionalDocumentsModel = values?.step2?.additionalDocuments;

  const additionalDocs = useMemo(
    () =>
      Object.entries(additionalDocumentsModel || {}).map(([id, name]) => ({
        id,
        name,
      })),
    [additionalDocumentsModel],
  );

  const addNewDocsHandler = () => {
    change(`${fieldsGroupName}.additionalDocuments._${Date.now()}`, "");
  };

  const deleteOtherDocumentHandler = (docId) => {
    change(`${fieldsGroupName}.additionalDocuments.${docId}`, undefined);
  };

  return (
    <div>
      <div className={classes.addNewButtonContainer}>
        <Button
          color={"success"}
          onClick={addNewDocsHandler}
          variant="contained"
          className={classes.addNewButton}
        >
          Add Other Document
        </Button>
      </div>
      <div className={classes.fieldArrayContainer}>
        {additionalDocs.map((doc) => (
          <div key={doc.id} className={classes.otherDoc}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={10} md={10}>
                <Field
                  fullWidth
                  type="text"
                  label="Other"
                  placeholder="Other document"
                  infoIcon={
                    "Indicate the docs which are not listed above and you require."
                  }
                  component={BootstrapInput}
                  parse={(value) =>
                    value === "" || value === null ? "" : value
                  }
                  name={`${fieldsGroupName}.additionalDocuments.${doc.id}`}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <IconButton
                  color={"delete"}
                  className={classes.removeOtherDocButton}
                  onClick={() => deleteOtherDocumentHandler(doc.id)}
                >
                  <FontIcon style={{ fontSize: 12 }} name={"delete"} />
                </IconButton>
              </Grid>
            </Grid>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdditionalRequiredDocs;
